<template>
  <v-card flat>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="4"
          >
            <VCheckbox
              v-model="data.all"
              :label="$t('tree.duplicateNode.component.all')"
              hideDetails
              @input="updateAllOption"
            />
            <VCheckbox
              v-model="data.analysis"
              :label="$t('tree.duplicateNode.component.analysisCard')"
              hideDetails
              @input="updateData"
            />
            <VCheckbox
              v-model="data.flowMeter"
              :label="$t('tree.duplicateNode.component.flowMeterCard')"
              hideDetails
              @input="updateData"
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
            md="4"
          >
            <VCheckbox
              v-model="data.productLevel"
              :label="$t('tree.duplicateNode.component.productLevelCard')"
              hideDetails
              @input="updateData"
            />
            <VCheckbox
              v-model="data.technicalFile"
              :label="$t('tree.duplicateNode.component.technicalFile')"
              hideDetails
              @input="updateData"
            />
            <VCheckbox
              v-model="data.treatmentProgram"
              :label="$t('tree.duplicateNode.component.treatmentProgram')"
              :disabled="!isCoolingNetwork"
              hideDetails
              @input="updateData"
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
            md="4"
          >
            <VCheckbox
              v-model="data.maintenanceSchedule"
              :label="$t('tree.duplicateNode.component.maintenanceSchedule')"
              :disabled="!isCoolingNetwork"
              hideDetails
              @input="updateData"
            />
            <VCheckbox
              v-model="data.controlChart"
              :label="$t('tree.duplicateNode.component.controlChart')"
              :errorMessages="controlChartError"
              :disabled="!data.analysis"
              @input="validateAndUpdateControlChart"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox.vue';
import { COOLING } from '@/aquassist-shared/constants/types/components';


export default {
    components: {
        VCheckbox,
    },
    props: {
        component: {
            type: Object,
            required: true,
        },
        network: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            data: {
                all: false,
                analysis: false,
                controlChart: false,
                maintenanceSchedule: false,
                treatmentProgram: false,
                technicalFile: false,
                productLevel: false,
                flowMeter: false,
            },
        };
    },
    computed: {
        isCoolingNetwork() {
            return this.network.typeKey === COOLING;
        },
        controlChartError() {
            // Show error message if controlChart is selected but analysis is not
            return this.data.controlChart && !this.data.analysis
                ? this.$t('tree.duplicateNode.component.controlChartValidationError')
                : '';
        },
    },
    watch: {
        'data.analysis': 'checkAllDeselected',
        'data.controlChart': 'checkAllDeselected',
        'data.maintenanceSchedule': 'checkAllDeselected',
        'data.treatmentProgram': 'checkAllDeselected',
        'data.technicalFile': 'checkAllDeselected',
        'data.productLevel': 'checkAllDeselected',
        'data.flowMeter': 'checkAllDeselected',
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
        updateAllOption() {
            this.data.analysis = this.data.all;
            this.data.controlChart = this.data.all;
            this.data.maintenanceSchedule = this.data.all;
            this.data.treatmentProgram = this.data.all;
            this.data.technicalFile = this.data.all;
            this.data.productLevel = this.data.all;
            this.data.flowMeter = this.data.all;
            this.updateData();
        },
        validateAndUpdateControlChart() {
            // If controlChart is selected but analysis is not, show error message
            // but don't automatically unselect it to let the user see the error
            if (this.data.controlChart && this.data.analysis) {
                this.updateData();
            }
        },
        checkAllDeselected() {
            const options = [
                this.data.analysis,
                this.data.controlChart,
                this.data.maintenanceSchedule,
                this.data.treatmentProgram,
                this.data.technicalFile,
                this.data.productLevel,
                this.data.flowMeter,
            ];
            if (options.some(opt => !opt) && this.data.all) {
                this.data.all = false;
            }
        },
    },

};
</script>
